import PropTypes from "prop-types";
import { ICON_SIZES } from "app/constants";
function FileStrokeIcon({ size, ...props }) {
	return (
		<svg
			viewBox="0 0 24 24"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
			{...size !== undefined && { width: size, height: size }}
			{...props}
		>
			<path
				d="M16 16.25C16.4142 16.25 16.75 16.5858 16.75 17C16.75 17.4142 16.4142 17.75 16 17.75H8C7.58579 17.75 7.25 17.4142 7.25 17C7.25 16.5858 7.58579 16.25 8 16.25H16Z"
				fill="currentColor"
			/>
			<path
				d="M12 12.25C12.4142 12.25 12.75 12.5858 12.75 13C12.75 13.4142 12.4142 13.75 12 13.75H8C7.58579 13.75 7.25 13.4142 7.25 13C7.25 12.5858 7.58579 12.25 8 12.25H12Z"
				fill="currentColor"
			/>
			<path
				d="M3.25 20V4C3.25 2.48122 4.48122 1.25 6 1.25H13C13.1989 1.25 13.3896 1.32907 13.5303 1.46973L20.5303 8.46973C20.6709 8.61038 20.75 8.80109 20.75 9V20C20.75 21.5188 19.5188 22.75 18 22.75H6C4.48122 22.75 3.25 21.5188 3.25 20ZM4.75 20C4.75 20.6904 5.30964 21.25 6 21.25H18C18.6904 21.25 19.25 20.6904 19.25 20V9.31055L12.6895 2.75H6C5.30964 2.75 4.75 3.30964 4.75 4V20Z"
				fill="currentColor"
			/>
			<path
				d="M12.25 7V2H13.75V7C13.75 7.69036 14.3096 8.25 15 8.25H20V9.75H15C13.4812 9.75 12.25 8.51878 12.25 7Z"
				fill="currentColor"
			/>
		</svg>
	);
}

FileStrokeIcon.propTypes = {
	size: PropTypes.oneOf(Object.values(ICON_SIZES)),
};

export default FileStrokeIcon;
